import gtxConstants from 'gtx-constants';

export const SHOW_REGISTRATION_BUSINESS_TYPE = Boolean(gtxConstants('SHOW_REGISTRATION_BUSINESS_TYPE'));
